import { useEffect, useState } from "react";
import { countryTaxConfigAPI, type CountryTaxConfig } from "@/api/countryTaxConfig";

/** The row in force today for a country. `config === null` with `loading === false` means not configured. */
export const useCountryTaxConfig = (countryCode: string) => {
	const [state, setState] = useState<{ code: string; config: CountryTaxConfig | null; loading: boolean }>({
		code: "",
		config: null,
		loading: false,
	});

	useEffect(() => {
		const code = countryCode.trim().toUpperCase();
		if (!code) {
			setState({ code: "", config: null, loading: false });
			return;
		}
		let cancelled = false;
		setState({ code, config: null, loading: true });
		countryTaxConfigAPI
			.getForCountry(code)
			.then((config) => {
				if (!cancelled) setState({ code, config, loading: false });
			})
			.catch(() => {
				if (!cancelled) setState({ code, config: null, loading: false });
			});
		return () => {
			cancelled = true;
		};
	}, [countryCode]);

	return state;
};
